import React from 'react';
import cx from '../../utils/classnames';
import styles from './dateButtonGroup.module.scss';

import { IconProps } from '@travel/icons';
import { IconColor } from '@travel/icons/withIconProps';

import DateButton, { CustomStyleType } from '../DateButton';

export type SelectedButton = 'startDate' | 'endDate' | string;
type Props = {
  className: string;
  /** Custom style for date button */
  buttonClassName: string;
  /** Custom props for date button icon */
  buttonIconProps?: IconProps;
  /** Custom height for button */
  customStyle?: CustomStyleType;
  /** Flag to define whether the highlight state will be shown or not */
  isShowSelectedState: boolean;
  /** String to define which button is selected */
  selectedButton: SelectedButton;
  /** Callback function when start date button is clicked */
  onClickStartDateButton: (event: React.MouseEvent) => void;
  /** Callback function when end date is clicked */
  onClickEndDateButton: (event: React.MouseEvent) => void;
  /** End date of selected range */
  endDate?: string;
  /** Start date of selected range */
  startDate?: string;
  /** String to define title of start date */
  startDateLabel: React.ReactNode;
  /** String to define title of end date */
  endDateLabel: React.ReactNode;
  /** Date component to specify custom format */
  DateComponent: React.ComponentType<{ value: string }>;
  /** Color when cursor is hovered */
  hoveredColor?: IconColor;
  /** Color when cursor is not hovered */
  unhoveredColor?: IconColor;
};

function DateButtonGroup(props: Props) {
  const {
    buttonClassName,
    buttonIconProps,
    className,
    customStyle,
    endDate,
    isShowSelectedState,
    startDate,
    selectedButton,
    onClickStartDateButton,
    onClickEndDateButton,
    startDateLabel,
    endDateLabel,
    DateComponent,
    hoveredColor,
    unhoveredColor,
  } = props;

  return (
    <div className={cx(className, styles.dateButtonGroupWrapper)}>
      <DateButton
        className={buttonClassName}
        iconProps={buttonIconProps}
        isSelected={isShowSelectedState && selectedButton === 'startDate'}
        customStyle={customStyle}
        label={startDateLabel}
        dateText={startDate}
        onClick={onClickStartDateButton}
        DateComponent={DateComponent}
        hoveredColor={hoveredColor}
        unhoveredColor={unhoveredColor}
      />
      <div className={styles.seperateLine} />
      <DateButton
        className={buttonClassName}
        iconProps={buttonIconProps}
        isSelected={isShowSelectedState && selectedButton === 'endDate'}
        customStyle={customStyle}
        label={endDateLabel}
        dateText={endDate}
        onClick={onClickEndDateButton}
        DateComponent={DateComponent}
        hoveredColor={hoveredColor}
        unhoveredColor={unhoveredColor}
      />
    </div>
  );
}

DateButtonGroup.defaultProps = {
  className: '',
  buttonClassName: '',
  selectedButton: 'checkin',
  isShowSelectedState: false,
  onClickStartDateButton: () => {},
  onClickEndDateButton: () => {},
  DateComponent: ({ value }: { value: string }) => value,
};

export default DateButtonGroup;
